/* eslint-disable react/function-component-definition */
import React, {useState, useEffect} from "react"

const NewsletterHelper = (props) => {
  const [newsletterReady, setNewsletterReady] = useState(false)
  const [newsletterName, setNewsletterName] = useState()
  const [newsletterShortName, setNewsletterShortName] = useState()
  const [consentUrlText, setConsentUrlText] = useState()
  const [introText, setIntroText] = useState()
  const [subscribeResponse, setSubscribeResponse] = useState()
  const headingClass = "text-2xl font-bold font-sans";
  const newsletterClass = props.minimalForm && props.minimalForm ? "email-subscription--min" : props.newsletterLocation == 'footer' ? "email-subscription--white" : NewsletterFormClass(props.newsletterType)
  const backgroundColor = props.backgroundColor
  const hideNewsletterForm = props.hide && props.hide
  const newsletterTerms =`<p class="font-sans text-xs leading-6">You must be over 18 to sign up to this newsletter.<br />
  Read our <a href="https://www.panmacmillan.com/privacy-notice" title="Pan Macmillan Privacy Notice" target="_blank" class="text-white underline">privacy notice</a> to find out how we hold and use your personal information.<br  />
  You can unsubscribe at any time.</p>`

  function NewsletterFormClass(newsletterType) {
    switch(newsletterType) {
      case "literary":
      case "literary_reads":
      case "classics":
      case "history":
          return "email-subscription--purple drop-shadow-xl"
      case "best_of_pan_macmillan_newsletter":
          return "email-subscription--blue drop-shadow-xl"
      case "best_of_pan_macmillan_newsletter__generic":
          return "email-subscription--white"          
      case "books_for_children":
      case "macmillan_kids":
          return "email-subscription--red drop-shadow-xl"
      case "ready_for_a_new_story___julia_donaldson_":
      case "friday_poem":
          return "email-subscription--green drop-shadow-xl"
      case "enchanted_chapters":
          return "email-subscription--midnight-blue drop-shadow-xl"
      default:
          return "email-subscription--blue drop-shadow-xl"
    }
  }

  function NewsletterFormID(newsletterType) {
    switch(newsletterType) {
      case "literary":
      case "literary_reads":
      case "classics":
      case "history":
          setNewsletterName("Literary Reads")
          setNewsletterShortName("LiteraryReads")
          setConsentUrlText(`I subscribe to the Literary Reads newsletter.`)
          setIntroText(`<h4>Looking for more world-class literature?</h4><p class="font-sans text-base">Sign up to the Literary Reads newsletter and be the first to discover the latest news from our award-winning authors.</p>`)
          return
      case "best_of_pan_macmillan_newsletter_menu":
        setNewsletterName("Best of Pan Macmillan")
        setNewsletterShortName("BestofMac")
        setConsentUrlText(`I subscribe to the Best of Pan Macmillan newsletter.`)
        setIntroText(`<p class="font-sans text-base">Sign up to the Best of Pan Macmillan newsletter to discover the best of our books, events and special offers.</p>`)
        return
      case "best_of_pan_macmillan_newsletter__generic":
      case "best_of_pan_macmillan_newsletter":
        setNewsletterName("Best of Pan Macmillan")
        setNewsletterShortName("BestofMac")
        setConsentUrlText(`I subscribe to the Best of Pan Macmillan newsletter.`)
        setIntroText(`<h4>Ready for your next read?</h4><p class="font-sans text-base">Sign up to the Best of Pan Macmillan newsletter to discover the best of our books, events and special offers.</p>`)
        return
      case "books_for_children":
      case "macmillan_kids":
          setNewsletterName("Macmillan Kids")
          setNewsletterShortName("MacmillanKids")
          setConsentUrlText(`I subscribe to the Macmillan Kids newsletter.`)
          setIntroText(`<h4>Looking for your next adventure?</h4><p class="font-sans text-base">Discover the next great story to spark the imagination of your little reader with our dedicated children's books newsletter.</p>`)
          return
      case "ready_for_a_new_story___julia_donaldson_":
        setNewsletterName("The Gruffalo & Other Stories")
        setNewsletterShortName("Gruffalo")
        setConsentUrlText(`I subscribe to The Gruffalo and Other Stories.*`)
        setIntroText(`<h4>Ready for a new story?</h4><p class="font-sans text-base">Discover more Julia Donaldson stories to spark the imagination of your little one, plus the latest events and activities based on her bestselling books, in The Gruffalo and Other Stories newsletter.</p>`)
        return
      case "friday_poem":
        setNewsletterName("Friday Poem")
        setNewsletterShortName("FridayPoem")
        setConsentUrlText(`I subscribe to the Friday Poem.`)
        setIntroText(`<h4>Ready to end your week on a high note?</h4><p class="font-sans text-base">Subscribe today for a poem, every Friday, delivered straight to your inbox.</p>`)
        return
      case "enchanted_chapters":
        setNewsletterName("Enchanted Chapters")
        setNewsletterShortName("EnchantedChapters")
        setConsentUrlText(`I subscribe to the Enchanted Chapters newsletter.`)
        setIntroText(`<h4>Make your next read a little more magical!</h4><p class="font-sans text-base">Subscribe to Enchanted Chapters and discover the best fantasy books, exclusive content, and incredible bookish surprises.</p>`)
        return
      default:
        setNewsletterName("Best of Pan Macmillan")
        setNewsletterShortName("BestofMac")
        setConsentUrlText(`I subscribe to the Best of Pan Macmillan newsletter.`)
        setIntroText(`<h4>Ready for your next read?</h4><p class="font-sans text-base">Sign up to the Best of Pan Macmillan newsletter to discover the best of our books, events and special offers.</p>`)
    }
  }

  function validateSignup(e) {
    let emailAddress = e.target.email.value;
    let errorString = '';
    let isError = false;
    const functionUrl = "/api/mappsubscribe"

    e.preventDefault()

    const emailSubscription = e.target.closest('.meganav-list__item.newsletter');
    emailSubscription?.parentElement?.scrollTo({ top: 0, behavior: 'smooth' });

    if (emailAddress == '' || emailAddress.indexOf('@') == -1) {
      errorString = 'Please enter your email address';
    }
  
    if (errorString.length > 0) {
        isError = true;
    }

    if(!isError) {
      fetch(functionUrl + "?emailAdd=" + emailAddress + "&newsletter=" + newsletterShortName + "&consent=" + consentUrlText)
      .then(response => {
        return response.json()
      })
      .then(data => {
        setSubscribeResponse(data)
      }).catch(error => {
        console.error('There has been an error:', error);
      });
    }

	if(window.dataLayer){
		window.dataLayer.push({
		  'event':'gatsbyGAEvent', 
		  'category':'Form', 
		  'action': `Newsletter ${newsletterName}`, 
		  'label': 'Submitted',
		})
	}
  }

  function NewsletterForm() {
    return <form key="signupPage" name="signupPage" id="signupPage" autoComplete="off" onSubmit={event => validateSignup(event)}>
      <span dangerouslySetInnerHTML={{ __html: introText }} />
      <p style={{textAlign:'left'}}>
        <label className="font-sans text-sm leading-7">Contact email <span style={{color:'#cc3300'}}>*</span>
        <input type="email" name="email" id="email" required aria-required="true" className="w-full p-4 border rounded-md border-black max-xl:text-black" />
        </label>
      </p>
      <p style={{textAlign:'left'}}>
      <label className="font-sans text-sm leading-7"><input type="checkbox" name="ci_userConsentCheckBox" id="ci_userConsentCheckBox" required aria-required="true" className="mr-2" />
      {consentUrlText}<span style={{color:'#cc3300'}}>*</span></label>
      </p>
      <p>
      <input type="submit" id="btnsubmit" name="btnsubmit" value="Subscribe" className="cursor-pointer pt-2.5 pb-2.5 pl-5 pr-5 font-sans font-bold text-center text-white bg-black border-black rounded-md text-base" data-newsletter={newsletterName} data-newsletter-location={props.newsletterLocation} />
      </p>
      <span className="newsletter--terms text-black" dangerouslySetInnerHTML={{ __html: newsletterTerms }} />
      </form>
  }

  function closeConfirmation() {
    setSubscribeResponse(undefined)
  }

  useEffect(() => {
    NewsletterFormID(props.newsletterType)
    setNewsletterReady(true)
  }, [props.newsletterType])

  function displayConfirmationSuccess() {
    return <>
    <p className="font-sans text-6 font-bold mb-4 pb-0 !text-black">Thank you for subscribing</p>
    <p className="font-sans text-6 !text-black">{subscribeResponse && subscribeResponse.email} has been subscribed to '{newsletterName}'</p>
    <span className="modal-terms" dangerouslySetInnerHTML={{ __html: newsletterTerms }} />
    </>
  }

  function displayConfirmationError() {
	if(subscribeResponse.status == 'validationerror'){
    return <>
<p className="font-sans text-6 font-bold mb-4 pb-0 !text-black">Oops something doesn't look right</p>
    <p className="font-sans text-6 !text-black">{subscribeResponse && subscribeResponse.message}</p>
    </>
	}
	else
	{
	 return <>
    <p className="font-sans text-6 font-bold mb-4 pb-0 !text-black">There has been a problem</p>
    <p className="font-sans text-6 !text-black">{subscribeResponse && subscribeResponse.message}</p>
    </>
	}
  }

  if(newsletterReady && !hideNewsletterForm && props.categories !== "young_adult") {
    return <>
      <div className={`email-subscription ${newsletterClass} rounded-md`} style={{backgroundColor: backgroundColor}} >
        <div className={props.newsletterType === "best_of_pan_macmillan_newsletter_menu" ? "w-4/5" : "max-w-[600px] mx-auto" }>
          <NewsletterForm />
        </div>
      </div>
      {subscribeResponse &&
        <div className="fixed top-0 left-0 right-0 bottom-0 bg-[rgba(255,255,255,0.6)] flex flex-wrap items-center justify-center z-[1000]">
          <div className="bg-white text-center p-6 rounded-md shadow-card email-subscription--white !text-black">
          {subscribeResponse.status === "success" ? displayConfirmationSuccess() : displayConfirmationError() }
          <p style={{margin: `1.5rem 0 0 0`}}><button className="button bg-green hover:!bg-green-light border border-green hover:!border-green-light text-black hover:!text-black" onClick={closeConfirmation}>{subscribeResponse.status === "success" ? 'Continue' : 'Try again' }</button></p>
          </div>
      </div>
      }
    </>
  } else {
      return null
  }
}

export default NewsletterHelper